import { useEffect } from 'react';
import wizardStateReducer from './wizard.state.reducer';
import useReducerWithThunk from 'components/hooks/useReducerWithThunk';
import {
  fetchProjectAreas,
  fetchProjectTeams,
  fetchTeamsAreas,
  onEditSelectedValue,
  setProjects
} from './wizard.state.actions';
import usePmImportStrategyEntity from 'views/root/views/home/views/settings/views/ProjectManagement/connected-components/PMConfiguration/components/PMEntities/hooks/PMHooks/usePmImportStrategyEntity';
import { PM_PROVIDERS, PROVIDERS_MAP } from 'common/constants/constants';
import { getAllEntitiesByEntityType } from 'components/FilterMenus/FilterMenus.service';
import { FILTER_TYPES } from 'common/constants/filters';

export const initialState = {
  projects: [],
  selectedProject: null,
  selectedTeam: null,
  projectTeams: [],
  projectAreas: [],
  teamAreas: [],
  selectedAreas: [],
  loadingActions: {},
  isWizardOpen: false,
  selectedValues: [], // { projectId, teamId, areas: [{}]}
  idxOnEdit: null
};

const useWizardState = ({ defaultSelectedValues, onChange }) => {
  const getSelectedProjectsObjects = async projects => {
    const allProjects = await getAllEntitiesByEntityType(
      PM_PROVIDERS.AZURE_BOARDS,
      FILTER_TYPES.PROJECTS
    );
    const selectedProjectsIds = projects.map(({ provider_id }) => provider_id);
    const selectedProjects = allProjects.items.filter(project =>
      selectedProjectsIds.includes(project.entity_id)
    );
    return selectedProjects;
  };
  const settingProjects = usePmImportStrategyEntity({
    entityName: PROVIDERS_MAP.azure_boards.entities_settings_keys.projects
  });
  const [wizardState, dispatch] = useReducerWithThunk(wizardStateReducer, {
    ...initialState,
    selectedValues: defaultSelectedValues
  });

  const isEditMode = wizardState.idxOnEdit !== null;

  useEffect(() => {
    if (wizardState.selectedProject?.id)
      dispatch(fetchProjectTeams(wizardState.selectedProject));
  }, [wizardState.selectedProject?.id]);

  useEffect(() => {
    if (wizardState.selectedTeam?.id) {
      dispatch(fetchTeamsAreas({ state: wizardState }));
    }
  }, [wizardState.selectedTeam?.id]);

  useEffect(() => {
    if (wizardState.selectedProject?.id)
      dispatch(fetchProjectAreas({ state: wizardState }));
  }, [wizardState.teamAreas]);

  useEffect(() => {
    if (isEditMode) {
      const selectedValueOnEdit =
        wizardState.selectedValues[wizardState.idxOnEdit];
      dispatch(onEditSelectedValue(selectedValueOnEdit));
    }
  }, [wizardState.idxOnEdit]);

  useEffect(() => {
    onChange(wizardState.selectedValues);
  }, [wizardState.selectedValues]);

  useEffect(() => {
    async function handle() {
      if (!!settingProjects.values.length) {
        const selectedProject = await getSelectedProjectsObjects(
          settingProjects.values
        );
        dispatch(setProjects(selectedProject));
      }
    }

    handle();
  }, [settingProjects.stringValues]);

  return {
    ...wizardState,
    isEditMode,
    dispatch
  };
};

export default useWizardState;
